/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";
import { Formik } from "formik";

/* Helpers, constants, custom methods, internal libraries */
import { useLoyaltyTermsAndConditionsService, useLoyaltyService } from "services/loyaltyService";
import { useUserContext } from "../../../contexts/userContext"
import { useLocaleContext } from "contexts/localeContext";

/* Components */
import UCCheckbox from "../../uccheckbox";
import QuillEditor from "../../../components/quillEditor/quillEditor";
import TextLoadingSpinner from "../../../components/spinners/textLoadingSpinner";

/* Styles */
import styles from "./styles.js";

const Content = (props) => {
  const { setShowModal, onTermsAccepted, setTermsAccepted } = props;
  const theme = useTheme();
  const classes = styles({ theme });

  const { postTermsAndConditions } = useLoyaltyTermsAndConditionsService();
  const userContext = useUserContext();
  const { getLoyaltyTermsAccepted, loyaltyAcceptedResponse, getTermsContent } = useLoyaltyService();
  const globalLocale = useLocaleContext();

  const [termsCheckbox, setTermsCheckbox] = useState(false);
  const [lepTermsAccepted, setLepTermsAccepted] = useState(false);
  const [termsContent, setTermsContent] = useState({})

  const formRef = useRef(null);
  const quillRef = useRef();
  const hasFetched = useRef(false); 

  const companyEntityId = userContext?.userInfo?.companyInfo?.companyEntityId;

  useEffect(() => {
    if (companyEntityId && !hasFetched.current) {
      hasFetched.current = true;
      getLoyaltyTermsAccepted(companyEntityId);
    }
  }, [companyEntityId, getLoyaltyTermsAccepted]);

  useEffect(() => {
    if (loyaltyAcceptedResponse !== undefined) {
      setLepTermsAccepted(loyaltyAcceptedResponse);
    }
  }, [loyaltyAcceptedResponse]);

  const getTermsData = async () => {
    const response = await getTermsContent({label: globalLocale});
    if (response) {
      setTermsContent(response.content?.ops)
    }
  };

  useEffect(() => {
    getTermsData();
  }, []);

  const submitForm = async () => {
    try {
      await postTermsAndConditions({ acceptTermsAndConditions: termsCheckbox });
      if (typeof onTermsAccepted === 'function') onTermsAccepted();
      setShowModal(false, "accepted");
      setTermsAccepted(true);
    } catch (error) {
      console.error("Error posting terms and conditions:", error);
    }
  };

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <div className={classes.modalContent}>
      <div className={!lepTermsAccepted ? classes.descriptionContainer : classes.descriptionContainerTall}>
        {termsContent && Object.keys(termsContent).length !== 0 ? (
          <QuillEditor
            ref={quillRef}
            defaultValue={termsContent}
            className={classes.quillEditor}
            readOnly={true}
          />
        ) : (
          <TextLoadingSpinner />
        )}
      </div>

      {!lepTermsAccepted && (
        <Formik
          innerRef={formRef}
          initialValues={{
            acceptTermsAndConditions: termsCheckbox,
          }}
          onSubmit={(values, { setSubmitting }) => {
            submitForm();
            setSubmitting(false);
          }}
        >
          {({
            handleSubmit
          }) => (
            <form onSubmit={handleSubmit}>
              <UCCheckbox
                className={classes.termsCheckbox}
                labelClass={classes.labelClass}
                checked={termsCheckbox}
                onChange={() => {
                  setTermsCheckbox(!termsCheckbox);
                }}
                label={<FormattedMessage id="loyalty.termsCheckbox" />}
              />
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row>
                    <Col className={classes.colRemove}>
                      <UCButton
                        className={classes.agreeBtn}
                        onClick={handleFormSubmit}
                        type="primary"
                        text={<FormattedMessage id="loyalty.termsAgreeButton" />}
                        spinner={{
                          name: "loyaltyTermsSpinner",
                          size: 20,
                        }}
                        disabled={!termsCheckbox}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default Content;
